const interfaceControls = {
  namespaced: true,
  state: {
    drawer: null
  },
  mutations: {
    setDrawer(state, drawer) {
      state.drawer = drawer
    }
  },
  actions: {
    setDrawer: function(context, payload) {
      context.commit('setDrawer', payload.drawer)
    }
  },
  getters: {
    getDrawer: state => state.drawer
  }
}

export default interfaceControls
